export const updateState = {
    BORRADOR: 0, //Cuando se inicializa una nueva actualización o se retoma una en proceso por el usuario  pero aun no se ha finalizado
    UNIFICACION: 1, //Cuando el usuario finaliza la actualización y esta pasa a la fase en que se crea el anexo unificado   
    VALIDACION: 2, //Cuando ya pasa a la bandeja para su validación por parte de los asesores
    RE_VALIDACION: 3, //Cuando ya pasa a la bandeja para su segunda validación por parte de los asesores
    ANULADA: 4,  //4 Cuando por algun motivo ya no se puede continuar el proceso con esa empresa 
    DEVUELTA: 5, //5 cuando por algun motivo no se puede continuar y se devuelve al usuario para corregir la afiliacion
    FINALIZADA: 9, //9 Cuandoe el asesor  finaliza el proceso de afiliacion de la postulación

}



export const DEVOLUCIONES_FORM = [

    {
        label: "",
        name: "datosdevolucion",
        type: "section",
        typeForm: "section",
        className: "rs-100",
        fields: [
            {
                //tooltip: "Seleccione el motivo de la anualación",
                label: "Motivo devolución",
                name: "motivoDevolucion",
                placeholder: "Motivo devolución",
                type: "autocomplete",
                typeForm: "autocomplete",
                value: false,
                options: [],
                disabled: false,
                className: "rs-40"
            },
            {
                //tooltip: "Ingresa la observacion pertinente",
                label: "Observación",
                name: "observation",
                placeholder: "Observación",
                type: "text",
                typeForm: "text",
                maxLength: 2000,
                value: false,
                options: [],
                disabled: false,
                className: "rs-60",
                hidden: false
            },

        ]
    }
]


export const PLANTILLA_DE_LA_GENTE = `<br/><br/><br/> 
<p style="text-align: center;"><span style="color: #008000;"><strong><em>Somos Delagente porque&nbsp;</em></strong></span><span style="color: #ffcc00;"><strong><em>trabajamos con amor</em></strong></span><span style="color: #008000;"><strong><em>&nbsp;para transformar la vida de las familias vallecaucanas.</em></strong></span></p>
<div style="width: 100%; margin:auto; display:flex">
<div style="height: 181px; margin:3%; padding:10px; ">
    <img src=${process.env.REACT_APP_URL_LOGO_COMFENALCO_DELAGENTE}></div>
<table style="height: 181px; align:rigth; width: 486px;">
<tbody>
<tr>
<td style="width: 228.792px;">&nbsp;</td>
<td style="width: 243.208px;">
<p><span style="font-weight: 400;">&nbsp;</span></p>
<p><span style="color: #008000;"><strong>Servicio al Cliente</strong></span></p>
<p><strong>Caja de Compensaci&oacute;n Familiar</strong></p>
<p><strong>Comfenalco Valle Delagente&nbsp;</strong></p>
<p><span style="font-weight: 400;">Horario atenci&oacute;n correo electr&oacute;nico: Lunes a viernes 7:30 a.m. a 6:00 p.m. y s&aacute;bados de 8 a.m. a 12 m.</span></p>
<p><strong>Tel&eacute;fono</strong><span style="font-weight: 400;">: (602) 886 2727, Opci&oacute;n 2</span><span style="font-weight: 400;"><br /><br /></span></p>
<p><a href="http://www.comfenalcovalle.com.co/"><span style="font-weight: 400;">www.comfenalcovalle.com.co</span></a></p>
<p><a href="https://www.comfenalcovalle.com.co/personas/servicio-al-cliente/formulario-pqrsf/"><span style="font-weight: 400;">Ir al formulario Cont&aacute;ctanos</span></a></p>
</td>
</tr>
</tbody>
</table>
</div>`;

export const ATTACHMENTS = [
    {
        filename: "logocomfe.jpeg",
        encoding: 'base64',
        content: "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"
    }
]

export const responseValidador = {
    "xsi": "http://www.w3.org/2001/XMLSchema-instance",
    "afiliado": {
        "idTiid": "1",
        "abreviatura": "CC",
        "identificacion": "13093823",
        "idPers": "101741626",
        "nombre": "RODRIGUEZ CERON HECTOR ",
        "fechaInicioServicios": null,
        "fechaAfiliacionSistema": "2016-04-11",
        "fechaAfiliacionEps": null,
        "tiempoAfiliacionSistema": null,
        "tiempoAfiliacion": "313",
        "tiempoCotizacionSistema": null,
        "tiempoCotizacion": null,
        "idEstr": "1",
        "estrato": "ESTRATO 1",
        "edad": "39",
        "idNive": null,
        "nivel": {},
        "idMuniResidencia": "259",
        "codigoLeyMunicipioRes": "76318",
        "municipioResidencia": "GUACARI - VALLE",
        "idMuniAtencion": null,
        "codigoLeyMunicipioAte": {},
        "municipioAtencion": {},
        "idRaes": null,
        "codigoLeyRaes": {},
        "idIps": null,
        "codigoLeyIps": {},
        "ipsAtencion": {},
        "nacidoPos": {},
        "restriccionSemanas": {},
        "grupoPrimario": "S",
        "serviciosUhcm": {},
        "idCaaf": "3",
        "calidadAfiliado": "COTIZANTE",
        "cabeza": "S",
        "principal": "S",
        "alianza": {},
        "idCate": "1",
        "categoria": "A",
        "activo": "S",
        "codigoLeyEps": {},
        "nombreEps": {},
        "codigoLeyCaja": {},
        "nombreCaja": {},
        "fechaDefuncion": null,
        "primerNombre": "HECTOR",
        "segundoNombre": {},
        "primerApellido": "RODRIGUEZ",
        "segundoApellido": "CERON",
        "sexo": "M",
        "direccionResidencia": "CL",
        "telefonoResidencia": {},
        "celular": "3108244300",
        "email": "ABCDEFG12@GMAIL.COM",
        "idBarrResidencia": "1104",
        "codigoLeyBarrioRes": "76318000001",
        "barrioResidencia": "EL DORADO",
        "idTiaf": "1",
        "tipoAfiliado": {},
        "fechaNacimiento": "1984-12-08",
        "idEsci": "4",
        "estadoCivil": "UNION LIBRE",
        "subsidio": "S",
        "idTidi": "4",
        "porcentajeDiscapacidad": null,
        "descripcionDiscapacidad": "SIN DISCAP."
    },
    "derechos": {
        "informacionDerecho": [
            {
                "fechaCreacion": null,
                "idDere": "6",
                "idTipc": "1",
                "idTidr": "3",
                "idUsua": "54142",
                "servicio": "S",
                "derecho": "RECREACION",
                "tipoPaciente": "CAJA",
                "tipoDerecho": "VALIDACIONES CORRECTAS",
                "idTiaf": "1",
                "descripcionTiaf": "DEPENDIENTE",
                "idClaf": "1",
                "descripcionClaf": "DEPENDIENTE",
                "idEsla": "1",
                "descripcionEsla": "ACTIVO",
                "porcLey1429": "100",
                "porcCobertura": "100",
                "porcAporte": null
            },
            {
                "fechaCreacion": null,
                "idDere": "7",
                "idTipc": "1",
                "idTidr": "3",
                "idUsua": "54142",
                "servicio": "S",
                "derecho": "EDUCACION",
                "tipoPaciente": "CAJA",
                "tipoDerecho": "VALIDACIONES CORRECTAS",
                "idTiaf": "1",
                "descripcionTiaf": "DEPENDIENTE",
                "idClaf": "1",
                "descripcionClaf": "DEPENDIENTE",
                "idEsla": "1",
                "descripcionEsla": "ACTIVO",
                "porcLey1429": "100",
                "porcCobertura": "100",
                "porcAporte": null
            },
            {
                "fechaCreacion": null,
                "idDere": "8",
                "idTipc": "1",
                "idTidr": "3",
                "idUsua": "54142",
                "servicio": "S",
                "derecho": "VIVIENDA",
                "tipoPaciente": "CAJA",
                "tipoDerecho": "VALIDACIONES CORRECTAS",
                "idTiaf": "1",
                "descripcionTiaf": "DEPENDIENTE",
                "idClaf": "1",
                "descripcionClaf": "DEPENDIENTE",
                "idEsla": "1",
                "descripcionEsla": "ACTIVO",
                "porcLey1429": "100",
                "porcCobertura": "100",
                "porcAporte": null
            },
            {
                "fechaCreacion": null,
                "idDere": "10",
                "idTipc": "1",
                "idTidr": "12",
                "idUsua": "54142",
                "servicio": "N",
                "derecho": "TURISMO",
                "tipoPaciente": "CAJA",
                "tipoDerecho": {},
                "idTiaf": "1",
                "descripcionTiaf": "DEPENDIENTE",
                "idClaf": "1",
                "descripcionClaf": "DEPENDIENTE",
                "idEsla": "1",
                "descripcionEsla": "ACTIVO",
                "porcLey1429": "100",
                "porcCobertura": "0",
                "porcAporte": null
            },
            {
                "fechaCreacion": null,
                "idDere": "27",
                "idTipc": "1",
                "idTidr": "3",
                "idUsua": "54142",
                "servicio": "S",
                "derecho": "KIT ESCOLAR",
                "tipoPaciente": "CAJA",
                "tipoDerecho": "VALIDACIONES CORRECTAS",
                "idTiaf": "1",
                "descripcionTiaf": "DEPENDIENTE",
                "idClaf": "1",
                "descripcionClaf": "DEPENDIENTE",
                "idEsla": "1",
                "descripcionEsla": "ACTIVO",
                "porcLey1429": "100",
                "porcCobertura": "100",
                "porcAporte": null
            }
        ]
    },
    "negocios": {},
    "cotizantes": {
        "informacionCotizante": {
            "idTiid": "1",
            "abreviatura": "CC",
            "identificacion": "13093823",
            "nombre": "RODRIGUEZ CERON HECTOR ",
            "idPers": "101741626",
            "idDere": null,
            "derecho": {},
            "idTidr": null,
            "grupo": "1350395",
            "principal": "S",
            "cabeza": "S",
            "activo": "S"
        }
    },
    "empresas": {
        "informacionEmpresa": {
            "idTiid": "3",
            "abreviatura": "NI",
            "identificacion": "891300513",
            "idSuem": "3660",
            "codigoSucursal": "1",
            "razonSocial": "ENERGIA CONTROLADA S.A.S.",
            "idEmprArp": "54142",
            "nombreArp": "CANIZALES ROJAS SIRIA MERCEDES",
            "mora": {},
            "idDere": null,
            "derecho": {},
            "idTidr": null,
            "idPers": "101741626",
            "servicio": "S",
            "fechaInicialContrato": "2020-09-01",
            "fechaFinalContrato": null,
            "fechaIngreso": "2020-09-01",
            "fechaRetiro": null,
            "horasMes": "240",
            "idClaf": "1",
            "idClec": "1107",
            "idDiad": null,
            "idEsla": "1",
            "descripcionEsla": "ACTIVO",
            "idPpap": "1",
            "idSect": null,
            "idTico": "1",
            "idTvin": null,
            "pagaSubsidio": "S",
            "salarioBase": "1621050",
            "salarioVariable": "N",
            "idCarg": "1170",
            "cargo": "OBREROS Y PEONES DE EXPLOTACIONES AGRÍCOLAS",
            "codigoLeyCargo": "9211",
            "direccion": "AV 4 NORTE   47 A N   05",
            "telefono": "6022886295",
            "ley1429": "N",
            "porcentajeLey1429": "100",
            "ibc": "2744935"
        }
    },
    "descuentos": {},
    "grupoFamiliar": {
        "informacionGrupo": [
            {
                "idTiid": "1",
                "abreviatura": "CC",
                "identificacion": "13093823",
                "idPare": null,
                "parentesco": {},
                "nombre": "RODRIGUEZ CERON HECTOR ",
                "idPers": "101741626",
                "secuencia": "1",
                "idPersCotizante": "101741626",
                "fechaNacimiento": "1984-12-08",
                "idCate": "1",
                "categoria": "A",
                "subsidio": "S",
                "activo": "S",
                "sexo": "M",
                "fechaAfiliacion": "2016-04-11"
            },
            {
                "idTiid": "1",
                "abreviatura": "CC",
                "identificacion": "1077865368",
                "idPare": "8",
                "parentesco": "COMPAÑERO",
                "nombre": "YUCUMA MORA EMERSON ",
                "idPers": "102564027",
                "secuencia": "1",
                "idPersCotizante": "101741626",
                "fechaNacimiento": "1992-12-11",
                "idCate": "1",
                "categoria": "A",
                "subsidio": "N",
                "activo": "S",
                "sexo": "F",
                "fechaAfiliacion": "2022-04-01"
            },
            {
                "idTiid": "2",
                "abreviatura": "TI",
                "identificacion": "1022980766",
                "idPare": "4",
                "parentesco": "HIJO",
                "nombre": "RODRIGUEZ GOMEZ JEICOL ANDREA",
                "idPers": "102564028",
                "secuencia": "1",
                "idPersCotizante": "101741626",
                "fechaNacimiento": "2010-10-14",
                "idCate": "1",
                "categoria": "A",
                "subsidio": "S",
                "activo": "S",
                "sexo": "M",
                "fechaAfiliacion": "2022-04-01"
            }
        ]
    },
    "pagosCot": {
        "informacionPago": [
            {
                "idTiid": "3",
                "abreviatura": {},
                "identificacion": "891300513",
                "idSuem": "3660",
                "codigoSucursal": "3660",
                "nombre": "CANIZALES ROJAS SIRIA MERCEDES",
                "fechaPago": "2024-10-03",
                "periodo": "2024-09-01",
                "dias": null,
                "ingresoBase": null,
                "valorPago": "177362500",
                "idPare": null,
                "parentesco": {},
                "idPers": "101741626"
            },
            {
                "idTiid": "3",
                "abreviatura": {},
                "identificacion": "891300513",
                "idSuem": "3660",
                "codigoSucursal": "3660",
                "nombre": "CANIZALES ROJAS SIRIA MERCEDES",
                "fechaPago": "2024-09-04",
                "periodo": "2024-08-01",
                "dias": null,
                "ingresoBase": null,
                "valorPago": "191739800",
                "idPare": null,
                "parentesco": {},
                "idPers": "101741626"
            }
        ]
    },
    "deudasCot": {
        "informacionDeuda": [
            {
                "idTiid": "3",
                "abreviatura": "3",
                "identificacion": "3",
                "idSuem": "3660",
                "codigoSucursal": "1",
                "nombre": "ENERGIA CONTROLADA S.A.S.",
                "periodo": "2024-04-01",
                "fechaGeneracion": "2024-06-07",
                "valor": "0",
                "idPare": null,
                "parentesco": {},
                "idDocu": {},
                "idPers": "101741626"
            },
            {
                "idTiid": "3",
                "abreviatura": "3",
                "identificacion": "3",
                "idSuem": "3660",
                "codigoSucursal": "1",
                "nombre": "ENERGIA CONTROLADA S.A.S.",
                "periodo": "2023-03-01",
                "fechaGeneracion": "2023-05-01",
                "valor": "0",
                "idPare": null,
                "parentesco": {},
                "idDocu": {},
                "idPers": "101741626"
            },
            {
                "idTiid": "3",
                "abreviatura": "3",
                "identificacion": "3",
                "idSuem": "3660",
                "codigoSucursal": "1",
                "nombre": "ENERGIA CONTROLADA S.A.S.",
                "periodo": "2023-02-01",
                "fechaGeneracion": "2023-04-10",
                "valor": "0",
                "idPare": null,
                "parentesco": {},
                "idDocu": {},
                "idPers": "101741626"
            }
        ]
    },
    "documentosAfil": {}
}

export const consultaOportunidadResponseWS = [
    {
        "fechaCreacion": "2024-11-08T19:47:22.691591Z",
        "idProducto": null,
        "nroOportunidad": "1002027",
        "nroTransaccion": "1002027",
        "asesor": "8000000630",
        "categoriaOportu": "B",
        "origenOportunidad": "Formulario Subsidio Vivienda.",
        "estadoOportunidad": "1 - Abierto",
        "cicloVentas": "Z02",
        "centroOrganizacional": "SUBVIVCAL01"
    }
]

export const traeInfoOportunidad = {
    "xsi": "http://www.w3.org/2001/XMLSchema-instance",
    "oportunidad": "1002027",
    "valorSFV": "20.00",
    "valorSubsidioOtorgado": "26000000",
    "step1": {
        "datospostulante": {
            "companyEmail": "ABCDEFG12@GMAIL.COM",
            "companyPhone": "3108244300",
            "currentAddress": "CL",
            "documentType": "CC",
            "hood": "EL DORADO",
            "firstName": "RODRIGUEZ CERON HECTOR",
            "middleName": "RODRIGUEZ CERON HECTOR",
            "lastName": "RODRIGUEZ CERON HECTOR",
            "namecity": "259",
            "namedepartament": "76",
            "nameidPlace": "CALI-VALLE",
            "numberId": "13093823"
        },
        "informacionbasica": {
            "homeModeType": "1",
            "homeType": "<Z02>",
            "planHomeVivienda": "VIS",
            "postulanteType": "1",
            "subsidio": "2",
            "entidadSubsidio": ""
        },
        "informacionlaboral": {
            "laborandoData": {
                "name": "ENERGIA TOTAL",
                "phone": "6024444444",
                "place": "CL 22  24 57"
            },
            "subsidioData": {
                "name": "ENERGIA CONTROLADA S.A.S.",
                "nit": "891300513",
                "phone": "3000000000",
                "place": "AV 4 NORTE   47 A N   05"
            }
        }
    },
    "step2": {
        "condicionHogar": {
            "birthdate": "1984-12-08",
            "companyName": "RODRIGUEZ CERON HECTOR",
            "documentType": "CC",
            "ingresos": "3000000",
            "jobJefeHogar": "6",
            "maritalstatusJefe": "4",
            "numDocJefe": "13093823",
            "parentezcoJefe": "1",
            "sex": "1",
            "special": "",
            "tipostulante": ""
        },
        "integrantesHogar": {
            "inthogarpostulantes": [
                {
                    "birthdatePostu": "1950-06-01",
                    "documentTypePostu": "CC",
                    "idPostu": "1111111",
                    "ingresosMensual": "0",
                    "jobPostu": "4",
                    "maritalstatusPostu": "1",
                    "namePostu": "CERON MARIN ELISA",
                    "nombrecajaPostu": "",
                    "postulantePostu": "",
                    "relativePostu": "6",
                    "sexPostu": "2",
                    "specialPostu": "3"
                },
                {
                    "birthdatePostu": "1992-12-11",
                    "documentTypePostu": "CC",
                    "idPostu": "1077865368",
                    "ingresosMensual": "0",
                    "jobPostu": "4",
                    "maritalstatusPostu": "4",
                    "namePostu": "YUCUMA MORA EMERSON",
                    "nombrecajaPostu": "",
                    "postulantePostu": "",
                    "relativePostu": "2",
                    "sexPostu": "2",
                    "specialPostu": ""
                },
                {
                    "birthdatePostu": "2010-10-14",
                    "documentTypePostu": "TI",
                    "idPostu": "1022980766",
                    "ingresosMensual": "0",
                    "jobPostu": "5",
                    "maritalstatusPostu": "1",
                    "namePostu": "RODRIGUEZ GOMEZ JEICOL ANDREA",
                    "nombrecajaPostu": "",
                    "postulantePostu": "",
                    "relativePostu": "3",
                    "sexPostu": "1",
                    "specialPostu": ""
                }
            ]
        },
        "totalingresos": {
            "salarioreportafiliacion": "2744935",
            "totalingresos": "3000000"
        }
    },
    "step3": {
        "informacionpostulacion": {
            "namecityPostu": "250",
            "namedepartamentPostu": "76",
            "ofername": "GAUDÍ CONSTRUCTORES",
            "projectname": "BARCELONA ETAPA I"
        },
        "modalidadvivienda": {
            "apple": "",
            "barrioModalidad": "",
            "escritura": "",
            "escriturafecha": "",
            "licencia": "",
            "loteaddress": "",
            "lotenumber": "",
            "namecityModalidad": "",
            "namedepartamentoModalidad": "",
            "notariaEscritura": "",
            "predioaddress": "",
            "projecttype": "",
            "propiedadlote": "",
            "registertestdate": "",
            "urbanizacion": "",
            "vencimientoLicencia": ""
        },
        "valorconstruccion": {
            "avaluocatastral": "0",
            "presupuesto": "0",
            "valortotal": "0"
        }
    },
    "step4": {
        "ahorroprevio": [
            {
                "entityA": {
                    "label": "FIDUCIARIA BANCOLOMBIA"
                },
                "openDateA": {
                    "label": "2023-02-03"
                },
                "safeValueA": {
                    "value": "10000000"
                },
                "tiporecursoA": {
                    "value": "5"
                }
            },
            {
                "entityA": {
                    "label": "FONDO NACIONAL DEL AHORRO"
                },
                "openDateA": {
                    "label": "2020-10-10"
                },
                "safeValueA": {
                    "value": "5000000"
                },
                "tiporecursoA": {
                    "value": "4"
                }
            },
            {
                "entityA": {
                    "label": "PORVENIR"
                },
                "openDateA": {
                    "label": "2023-02-15"
                },
                "safeValueA": {
                    "value": "6000000"
                },
                "tiporecursoA": {
                    "value": "2"
                }
            }
        ],
        "cuentasCredito": {
            "entityFuente": "36",
            "fuentesFinanciamiento": "2",
            "openDateFuente": "2024-02-15"
        },
        "financiaciontotal": {
            "cierre": "",
            "totalahorroprevio": "21000000",
            "totalrecursos": "170000000",
            "valorsubcidiado": "26000000",
            "valorvivienda": "195000000"
        },
        "recursoscomplementarios": [
            {
                "entityR": {
                    "label": ""
                },
                "openDateR": {
                    "label": ""
                },
                "safeValueR": {
                    "value": "0"
                },
                "tiporecursoR": {
                    "value": "5"
                }
            },
            {
                "entityR": {
                    "label": ""
                },
                "openDateR": {
                    "label": ""
                },
                "safeValueR": {
                    "value": "170000000"
                },
                "tiporecursoR": {
                    "value": "1"
                }
            },
            {
                "entityR": {
                    "label": ""
                },
                "openDateR": {
                    "label": ""
                },
                "safeValueR": {
                    "value": "0"
                },
                "tiporecursoR": {
                    "value": "2"
                }
            },
            {
                "entityR": {
                    "label": ""
                },
                "openDateR": {
                    "label": ""
                },
                "safeValueR": {
                    "value": "0"
                },
                "tiporecursoR": {
                    "value": "3"
                }
            },
            {
                "entityR": {
                    "label": ""
                },
                "openDateR": {
                    "label": ""
                },
                "safeValueR": {
                    "value": "0"
                },
                "tiporecursoR": {
                    "value": "4"
                }
            }
        ],
        "totalahorroprevio": {
            "totalAhorro": "21000000"
        },
        "totalrecursoscomplementarios": {
            "totalComple": "170000000"
        }
    }
}

export const consumeWsPLanes = {
    "xsi": "http://www.w3.org/2001/XMLSchema-instance",
    "valorSalarioMinimo": {},
    "plan": [
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c662d96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "2",
            "modalidadSubsidio": "5",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "18200000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c664d96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "2",
            "modalidadSubsidio": "10",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "13000000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c666d96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "1",
            "modalidadSubsidio": "10",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "13000000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c668d96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "2",
            "modalidadSubsidio": "6",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "23400000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c66ad96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "1",
            "modalidadSubsidio": "6",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "23400000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c66cd96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "1",
            "modalidadSubsidio": "5",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "18200000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c66ed96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "2",
            "modalidadSubsidio": "1",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "39000000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c670d96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "2",
            "modalidadSubsidio": "2",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "23400000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c672d96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "2",
            "modalidadSubsidio": "3",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "23400000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c674d96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "2",
            "modalidadSubsidio": "4",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "279500000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c676d96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "1",
            "modalidadSubsidio": "1",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "39000000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c678d96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "1",
            "modalidadSubsidio": "2",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "23400000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c67ad96",
            "cicloVenta": "Z02",
            "nombreCicloVenta": "<Z02>",
            "planVivienda": "1",
            "modalidadSubsidio": "3",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "18200000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c67cd96",
            "cicloVenta": "Z03",
            "nombreCicloVenta": "<Z03>",
            "planVivienda": "2",
            "modalidadSubsidio": "1",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "91000000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c67ed96",
            "cicloVenta": "Z03",
            "nombreCicloVenta": "<Z03>",
            "planVivienda": "2",
            "modalidadSubsidio": "3",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "28600000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c680d96",
            "cicloVenta": "Z03",
            "nombreCicloVenta": "<Z03>",
            "planVivienda": "2",
            "modalidadSubsidio": "2",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "91000000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c682d96",
            "cicloVenta": "Z03",
            "nombreCicloVenta": "<Z03>",
            "planVivienda": "1",
            "modalidadSubsidio": "1",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "91000000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c684d96",
            "cicloVenta": "Z03",
            "nombreCicloVenta": "<Z03>",
            "planVivienda": "1",
            "modalidadSubsidio": "2",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "91000000"
        },
        {
            "SAP_UUID": "81d906e2-a3dd-1edf-aabc-12008c686d96",
            "cicloVenta": "Z03",
            "nombreCicloVenta": "<Z03>",
            "planVivienda": "1",
            "modalidadSubsidio": "3",
            "fechaSubsidio": "2024-11-23",
            "valorSubsidio": "28600000"
        }
    ]
}
